import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion, useScroll, useSpring } from "framer-motion";

import { Seo } from "../seo/Seo";
import { SITE } from "../seo/states";
import { Loader } from "../sections/Loader";
import { Navbar } from "../sections/Navbar";
import { Hero } from "../sections/Hero";
import { MarqueeStrip } from "../sections/MarqueeStrip";
import { Stats } from "../sections/Stats";
import { Services } from "../sections/Services";
import { Manifesto } from "../sections/Manifesto";
import { Timeline } from "../sections/Timeline";
import { Pricing } from "../sections/Pricing";
import { Websites } from "../sections/Websites";
import { Portfolio } from "../sections/Portfolio";
import { Testimonials } from "../sections/Testimonials";
import { About } from "../sections/About";
import { FAQ } from "../sections/FAQ";
import { Booking } from "../sections/Booking";
import { Contact } from "../sections/Contact";
import { Footer } from "../sections/Footer";
import { WhatsAppButton } from "../sections/WhatsAppButton";

export default function Home() {
  const location = useLocation();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.4 });

  // Scroll to hash target when navigating from an inner page (e.g. /#booking)
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const scroll = () => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      const t = setTimeout(scroll, 400);
      return () => clearTimeout(t);
    }
  }, [location]);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    name: "Alexa Financial Multiservices",
    url: SITE,
    description: "Maryland LLC formation, EIN registration, business funding, business credit, credit repair and professional website design.",
    areaServed: "United States",
    telephone: "+1-240-817-6538",
    email: "Alexaguzman407@gmail.com",
    founder: { "@type": "Person", name: "Alexa Guzman" },
  };

  return (
    <div className="App grain" data-testid="app-root">
      <Seo
        title="Alexa Financial Multiservices | Building Businesses Ready to Grow"
        description="Maryland LLC formation, EIN registration, business funding, business credit, credit repair & professional website design. Building businesses ready to grow — serving Maryland & nationwide."
        keywords="LLC Formation, Maryland LLC, EIN Registration, Business Funding, Business Credit, Credit Repair, Professional Website Design, Maryland Business Services"
        canonical={SITE + "/"}
        jsonLd={jsonLd}
      />
      <Loader onDone={() => {}} />

      <motion.div
        data-testid="scroll-progress"
        style={{ scaleX }}
        className="fixed top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-[#f3e5ab] to-[#d4af37] origin-left z-[60]"
      />

      <Navbar />
      <main>
        <Hero />
        <MarqueeStrip />
        <Stats />
        <Services />
        <Manifesto />
        <Timeline />
        <Pricing />
        <Websites />
        <Portfolio />
        <Testimonials />
        <About />
        <FAQ />
        <Booking />
        <Contact />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
